import { styled, Box, Typography } from '../../../base';

export const CardWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
    width: 82,
    height: 82,
    borderRadius: '50%',
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
        color: theme.palette.primary.main,
        fontSize: 29,
    },
}));

export const ContentWrapper = styled(Box)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
});

export const ChangeIndicator = styled(Typography)<{ ispositive: 'true' | 'false' }>(
    ({ ispositive, theme }) => ({
        color: ispositive === 'true' ? theme.palette.success.main : theme.palette.error.main,
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
        '&::before': {
            content: '""',
            width: 0,
            height: 0,
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderBottom: ispositive === 'true' ? `4px solid ${theme.palette.success.main}` : 'none',
            borderTop: ispositive === 'true' ? 'none' : `4px solid ${theme.palette.error.main}`,
        },
    })
);